import React, { useState,useEffect ,useRef} from "react";
import { Container, Row, Col } from "reactstrap";
import { useParams } from "react-router-dom";
import products from "../assets/data/products";
import Helmet from "../components/helmet/Helmet";
import ShopSection from "../components/ui/ShopSection";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import { cartActions } from "../redux/silces/cartSilces";
import { ToastContainer, toast } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
import ProductsList from "../components/ui/ProductsList";


import "../style/product-details.css";
const ProductsDetails = () => {
	const { id } = useParams();
	const product = products.find((item) => item.id === id);
	const [tab, setTeb] = useState("desc");
	const [rating,setRating ] = useState();
	const reviewUser = useRef('');
	const reviewMsg = useRef("");
	const dispatch = useDispatch();
	const {
		imgUrl,
		productName,
		shortDesc,
		price,
		avgRating,
		reviews,
		description,
		category
	} = product;

	const relatedProducts = products.filter(item => item.category===category);

	//

	const submitHandler = (e) => {
		e.preventDefault()

		const reviewUserName = reviewUser.current.value
		const reviewUserMsg = reviewMsg.current.value

		// console.log(reviewUserName, reviewUserMsg,rating);
			const reviewObj = {
				author:reviewUserName,
				text:reviewUserMsg,
				rating:rating,
			};
			toast("Product added successfully");
			// toast.success("Product added successfully");

	}

	//

	const addToCart = () => {
		dispatch(cartActions.addItem({
			id,
			image:imgUrl,
			productName,
			price,
		}))
		toast("Product added successfully");

		// toast.success('Product added successfully')
	}

	useEffect(() => {
		window.scrollTo(0,0)
	},[product])
	return (
		<Helmet title={productName}>
			<ShopSection title={productName} />

			<section className="pt-0">
				<Container>
					<Row>
						<Col lg="6">
							<img src={imgUrl} alt="" />
						</Col>
						<Col lg="6">
							<div className="product__details">
								<h2>{productName}</h2>
								<div className="product__rating d-flex align-items-center gap-5 mb-4">
									<div>
										<span>
											<i className="ri-star-s-fill"></i>
										</span>
										<span>
											<span>
												<i className="ri-star-s-fill"></i>
											</span>
											<span>
												<i className="ri-star-s-fill"></i>
											</span>
											<span>
												<i className="ri-star-s-fill"></i>
											</span>
											<i className="ri-star-half-s-fill"></i>
										</span>
									</div>
									<p>
										(<span>{avgRating}</span>rating)
									</p>
								</div>
								<div className="d-flex align-items-center gap-5">
									<span className="product__price">${price}</span>
									<span>Category : {category.toUpperCase()}</span>
								</div>
								<p className="mt-3">{shortDesc}</p>
								<motion.button
									whileTap={{ scale: 1.2 }}
									className="buy__btn"
									onClick={addToCart}
								>
									Add to Cart
								</motion.button>
								<ToastContainer />
							</div>
						</Col>
					</Row>
				</Container>
			</section>

			<section>
				<Container>
					<Row>
						<Col lg="12">
							<div className="tab__wrapper d-flex algin-items-center gap-5">
								<h6
									className={`${tab === "desc" ? "active__tab" : ""}`}
									onClick={() => setTeb("desc")}
								>
									description
								</h6>
								<br />
								<h6
									className={`${tab === "rev" ? "active__tab" : ""}`}
									onClick={() => setTeb("rev")}
								>
									Reviews ({reviews.length})
								</h6>
							</div>

							{tab === "desc" ? (
								<div className="tab__contaent mt-4">
									<p>{description}</p>
								</div>
							) : (
								<div className="products__reviews mt-5">
									<div className="reviews__wrapper">
										<ul>
											{reviews.map((item, index) => (
												<li key={index} className="mb-4">
													<h6>Albaron </h6>
													<span>{item.rating} (rating)</span>
													<p>{item.text}</p>
												</li>
											))}
										</ul>
										<div className="review__form">
											<h4>Leave your experience</h4>
											<form accessKey="" onSubmit={submitHandler}>
												<div className="form__grop">
													<input
														type="text"
														placeholder="Enter Name"
														required
														ref={reviewUser}
													/>
												</div>
												<div className="form__grop d-flex align-items-center gap-5">
													<motion.span
														whileTap={{ scale: 1.2 }}
														onClick={() => setRating(1)}
													>
														1<i className="ri-star-s-fill"></i>
													</motion.span>
													<motion.span
														whileTap={{ scale: 1.2 }}
														onClick={() => setRating(2)}
													>
														2<i className="ri-star-s-fill"></i>
													</motion.span>
													<motion.span
														whileTap={{ scale: 1.2 }}
														onClick={() => setRating(3)}
													>
														3<i className="ri-star-s-fill"></i>
													</motion.span>
													<motion.span
														whileTap={{ scale: 1.2 }}
														onClick={() => setRating(4)}
													>
														4<i className="ri-star-s-fill"></i>
													</motion.span>
													<motion.span
														whileTap={{ scale: 1.2 }}
														onClick={() => setRating(5)}
													>
														5<i className="ri-star-half-s-fill"></i>
													</motion.span>
												</div>
												<div className="form__grop">
													<textarea
														ref={reviewMsg}
														required
														rows={4}
														type="text"
														placeholder="Review Message..."
													/>
												</div>
												<button type="submit" className="buy__btn">
													Submit
												</button>
											</form>
										</div>
									</div>
								</div>
							)}
						</Col>
						<Col lg="12" className="mt-5">
							<h2 className="related__title">You might also like</h2>
						</Col>
						<ProductsList data={relatedProducts} />
					</Row>
				</Container>
			</section>
		</Helmet>
	);
};

export default ProductsDetails;
